import React, { useState } from "react";
import { brand } from "../theme/brand.js";
import { btnPrimary } from "../theme/button-styles.js";
import { cardStyle } from "../theme/card-styles.js";
import { inputStyle, labelStyle } from "../theme/input-styles.js";
import { useAuth } from "../hooks/useAuth.js";
import { updatePassword } from "../lib/auth.js";

/**
 * Shown when someone opens an invite or password-reset link (see
 * AUTH_LINK_TYPE in lib/supabase.js): the link has already signed them in,
 * so they only choose a password, then go on to the admin dashboard.
 */
export function SetPassword({ kind, onDone }) {
  // The link's raw Supabase session (staff profile loads a moment later).
  const { guestUser: user, loading } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (saving) return;
    if (password.length < 8) return setErrorMessage("Use at least 8 characters.");
    if (password !== confirm) return setErrorMessage("The two passwords don't match.");
    setSaving(true);
    try {
      await updatePassword(password);
      onDone();
    } catch (err) {
      setErrorMessage(err?.friendlyMessage || err?.message || "Could not save your password.");
      setSaving(false);
    }
  };

  const expired = !loading && !user;

  return (
    <div style={{ maxWidth: "380px", margin: "80px auto", padding: "0 24px" }}>
      <div style={cardStyle}>
        <h3 style={{ margin: "0 0 4px 0", fontSize: "16px", fontWeight: "600", color: brand.prussianBlue, fontFamily: brand.font }}>
          {kind === "invite" ? "Welcome to Novo Navigator" : "Choose a new password"}
        </h3>
        {expired ? (
          <p style={{ margin: "0 0 12px 0", fontSize: "13px", color: brand.textSecondary, lineHeight: 1.5 }}>
            This link has expired or was already used. Ask a Navigator admin to send you a new one
            (Admin Dashboard → Team → Send sign-in link).
          </p>
        ) : (
          <>
            <p style={{ margin: "0 0 20px 0", fontSize: "13px", color: brand.textSecondary }}>
              {kind === "invite" ? "Choose a password for your admin account." : "Enter your new password."}
              {user?.email && <><br />Account: <strong>{user.email}</strong></>}
            </p>
            <label style={labelStyle}>New password</label>
            <input
              type="password"
              autoComplete="new-password"
              style={{ ...inputStyle, marginBottom: "10px" }}
              value={password}
              onChange={(e) => { setPassword(e.target.value); setErrorMessage(""); }}
              autoFocus
            />
            <label style={labelStyle}>Type it again</label>
            <input
              type="password"
              autoComplete="new-password"
              style={{ ...inputStyle, marginBottom: "12px" }}
              value={confirm}
              onChange={(e) => { setConfirm(e.target.value); setErrorMessage(""); }}
              onKeyDown={(e) => e.key === "Enter" && save()}
            />
            {errorMessage && (
              <p style={{ margin: "0 0 12px 0", fontSize: "12px", color: brand.dangerRed }}>{errorMessage}</p>
            )}
            <button style={btnPrimary} onClick={save} disabled={saving || loading}>
              {saving ? "Saving…" : "Save password"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
